import { ObjectiveAttribute } from '@repo/types/src/glow-up';
import { ObjectiveAttributeCard } from './ObjectiveAttributeCard';

type ObjectiveAttributeListProps = {
  attributes: ObjectiveAttribute[];
  refetch: () => void;
};

export const ObjectiveAttributeList = ({
  attributes,
  refetch,
}: ObjectiveAttributeListProps) => {
  if (!attributes.length) {
    return (
      <p className="text-sm text-muted-foreground">
        Aucun attribut d’objectif pour le moment.
      </p>
    );
  }

  return (
    <div className="flex flex-wrap gap-4">
      {attributes.map((attribute) => (
        <ObjectiveAttributeCard
          key={attribute.id}
          attribute={attribute}
          refetch={refetch}
        />
      ))}
    </div>
  );
};
